import React, { PropsWithChildren } from "react";
const ReviewText = ({
  children
}: PropsWithChildren) => {
  return <p className="mb-0 text-gray-800 text-base text-ellipsis" data-sentry-component="ReviewText" data-sentry-source-file="index.tsx">{children}</p>;
};
export default ReviewText;